import { DefaultCarPageComponentProps } from "@/app/interface/components";
import CustomLink from "@/app/components/CustomLink";
import Link from "next/link";

function NavBar({
  car,
  model,
  setModel,
  setVersion,
  setColor,
}: DefaultCarPageComponentProps) {
  return (
    <header className="flex sticky top-16 z-30 flex-wrap gap-10 justify-between items-center self-center px-14 py-5 w-full bg-black min-h-[90px] max-md:px-5 max-md:max-w-full">
      <div className="flex flex-wrap gap-8 items-center self-stretch py-2 my-auto min-w-[240px] max-md:max-w-full">
        <h1 className="my-auto text-2xl leading-tight text-center text-white">
          {car?.exibition}
        </h1>
        <div className="flex overflow-hidden justify-center self-stretch  my-auto text-xs leading-snug whitespace-nowrap bg-white border border-solid border-zinc-500 min-w-[240px] rounded-[50px] text-zinc-500 w-[331px]">
          {car?.models.map((m, index) => (
            <div
              key={m.name + index}
              className={`flex flex-1  cursor-pointer gap-4 justify-center items-center text-black px-4 py-2 h-full border-r border-l border-zinc-500 ${
                model?.name === m.name && "bg-neutral-500 text-white"
              }`}
              onClick={() => {
                setModel && setModel(m);
                setVersion && setVersion(m.versions[0]);
                setColor && setColor(m.versions[0].colors[0]);
              }}
            >
              <div className="flex gap-1 items-center">
                <p>{m.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <nav className="flex flex-wrap gap-8 justify-center items-center self-stretch my-auto leading-snug text-center min-w-[240px] max-md:max-w-full">
        <ul className="flex gap-6 justify-center items-center my-auto text-base text-white min-w-[240px]">
          <li key={"a2"}>
            <CustomLink href="#visao-geral">Visão geral</CustomLink>
          </li>
          <li key={"b2"}>
            <CustomLink href="#galeria">Galeria</CustomLink>
          </li>
          <li key={"c2"}>
            <CustomLink href="#tss">TSS</CustomLink>
          </li>
          <li key={"d2"}>
            <CustomLink href="#diferenciais">Diferenciais</CustomLink>
          </li>
        </ul>
        <CustomLink
          href="#proposta"
          className="gap-2.5 self-stretch px-4 py-3 my-auto text-lg text-white bg-red-600 rounded-[29px] shadow-[0px_0px_3px_rgba(255,0,0,1)]"
        >
          Solicitar atendimento
        </CustomLink>
      </nav>
    </header>
  );
}

export default NavBar;
